import { isDetectedDataset } from 'js/lib/ResourceUtils';

type Sources = {
  [key: string]: {
    runtime_status?: RuntimeStatus;
  };
};

type RuntimeStatus = 'IDLE' | 'PROCESSING';

/**
 * Gets the runtime status for a dataset or flow item,
 * detected datasets handled specially - uses source runtime status instead
 * @param item - The dataset or flow item to get status for
 * @param sources - Sources data from entities store
 * @returns The determined runtime status
 */
export function getRuntimeStatus(
  item: {
    type?: string;
    data_source_id?: string;
    runtime_status?: RuntimeStatus;
  },
  sources?: Sources,
): RuntimeStatus {
  if (item?.type === 'DATA_SET' && isDetectedDataset(item)) {
    return sources?.[item.data_source_id]?.runtime_status ?? 'IDLE';
  }
  return item?.runtime_status ?? 'IDLE';
}
